import cards from 'assets/core/js/page/cms/cards'
import form from 'assets/core/js/page/cms/form'
import sliders from 'assets/core/js/page/cms/sliders'
import filters from 'assets/core/js/page/search/base/filters'
import searchMobileActions from 'assets/core/js/page/search/base/search-mobile-actions'
import searchMobileRecap from 'assets/core/js/page/search/base/search-mobile-recap'
import searchSelectedFilters from 'assets/core/js/page/search/base/selected-filters'

export default (): void => {
  sliders()
  cards()
  form()
  filters()
  searchMobileRecap()
  searchMobileActions()
  searchSelectedFilters()
}
